import { Brand } from '../Brand';

export default function Comparison() {
  return (
    <section className="section comparison">
      <div className="container comparison__inner">
        <h2 className="comparison__title">Help that arrives now, for a fraction of the cost.</h2>

        <div className="comparison__bars">
          <div className="bar bar--reeve">
            <div className="bar__col bar__col--reeve">
              <span className="bar__col-label">
                <Brand />
              </span>
            </div>
            <div className="bar__price">From £50</div><br />
          </div>
          <div className="bar bar--trad">
            <div className="bar__col bar__col--trad">
              <span className="bar__col-label bar__col-label--sub">
                Traditional
                <br />
                HR consultant
              </span>
            </div>
            <div className="bar__price">£150–£300+</div><br />
          </div>
          <div className="bar bar--inhouse">
            <div className="bar__col bar__col--inhouse">
              <span className="bar__col-label bar__col-label--sub">
                In-house
                <br />
                advisor
              </span>
            </div>
            <div className="bar__price">£2,500+</div><br />
          </div>
          <div className="bar bar--alone">
            <div className="bar__col bar__col--alone">
              <span className="bar__risk-label">
			  £
			  <br />
                Uncapped
                <br />
                risk
              </span>
              <span className="bar__solid">
                <span className="bar__col-label bar__col-label--sub">
                  Going it
                  <br />
                  alone
                </span>
              </span>
            </div>
            <div className="bar__price">
              Your time <br /><span>+ the risk</span>
            </div>
          </div>
        </div>

        <div className="compare-cols">
          <div className="compare-card compare-card--reeve">
            <div className="compare-card__title">
              With <Brand />
            </div>
            <div className="compare-card__list">
              <span>Instant answers, any time</span>
              <span>Live view on your risks</span>
              <span>Based in your own documents</span>
              <span>Human experts just one click away</span>
              <span>Completely private</span>
            </div>
          </div>
          <div className="compare-card compare-card--plain compare-card--trad">
            <div className="compare-card__title">Traditional HR consultant</div>
            <div className="compare-card__list">
              <span>Wait for a callback</span>
              <span>Expensive</span>			  
              <span>Long-term contracts</span>
              <span>Not personal</span>
              <span>Your questions logged in their system</span>
            </div>
          </div>
          <div className="compare-card compare-card--plain compare-card--inhouse">
            <div className="compare-card__title">In-house advisor</div>
            <div className="compare-card__list">
              <span>A dedicated HR person</span>
              <span>Knows your business</span>
              <span>Hands-on, in person, but office hours</span>
              <span>Very expensive</span>			  
              <span>Another employee</span>
            </div>
          </div>
          <div className="compare-card compare-card--plain compare-card--alone">
            <div className="compare-card__title">Going it alone</div>
            <div className="compare-card__list">
              <span>Guess, or hope ChatGPT's right</span>
              <span>Not grounded in UK law</span>
              <span>No one to escalate to</span>
              <span>Taking risks you don't even know about</span>
			  <span>Your questions end up as training data</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
